export default "__VITE_ASSET__DTmhgmjF__";